// @flow

import SeoPageTemplate from './seo-pages'

export default SeoPageTemplate
